import React, { useEffect, useState, useContext } from "react";
import FilterSelect from "../../components/Filter/FilterSelect";
import "./PublicationData.scss";
import MetricsCard from "../../components/MetricsCard/MetricsCard";
import Tabs from "../../components/Tabs/Tabs";
import { useNavigate, useLocation } from "react-router-dom";
import HeaderNavigate from "../../components/headerNavigate/HeaderNavigate";
import PublisherContent from "../../components/PublisherContent/PublisherContent";
import PublicationDetails from "../../components/PublicationDetails/PublicationDetails";
import AxiosService from "../../utils/AxiosService";
import Loader from "../../components/Loader/Loader";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCustomSearchParams } from "../../components/hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { KEY_NAME } from "../../utils/KeyName";
import { AppContext } from "../../context/AppContext";
import FilterBy from "../../components/Filter/FilterBy/FilterBy";
import ImageContainer from "../../components/imageContainer/ImageContainer";
import EntityHeader from "../../components/dashboardLayout/EntityHeader/EntityHeader";

const today = new Date();

const formattedDate = today.toLocaleDateString("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

const PublicationData = () => {
  const { get, set, setMultiple } = useCustomSearchParams();
  const { entityName, selectedFilterBy, selectedFilterByLabel, metaInfo } = useContext(AppContext);
  // const tabList = ["Publication Details", "Publisher Content"];

  const tabList =
    entityName === KEY_NAME.FUNDER
      ? ["Publication Details", "Publisher Content"]
      : ["Publication Details", "Funder Content"];

  // const [tabList, setTabList] = useState()
  const [activeTab, setActiveTab] = useState(
    get(SEARCH_PARAMS.TAB) || tabList[0],
  );
  const [showActiveTab, setShowActiveTab] = useState(true);
  const navigate = useNavigate();
  const [publisher, setPublisher] = useState("all");
  const location = useLocation();
  const funderName = location.state?.funderName || "Funder";
  const [publisherReportData, setPublisherReportData] = useState(null);
  const [publicationDetailsData, setPublicationDetailsData] = useState(null);
  const [publisherCount, setPublisherCount] = useState(null);
  const [selectedPublisher, setSelectedPublisher] = useState(
    get(SEARCH_PARAMS.ACTIVE_METRICS_CARD) || "workCount",
  );
  const [loading, setLoading] = useState(true);
  const [metricsLoading, setMetricsLoading] = useState(true);
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const [queryData, setQueryData] = useState({
    sortKey:
      activeTab === tabList[1]
        ? get(SEARCH_PARAMS.SORT_KEY) || "workCount"
        : get(SEARCH_PARAMS.SORT_KEY) || "title",
    sortOrder: get(SEARCH_PARAMS.SORT_ORDER) || "desc", //"asc", //"desc",
    filter: "", //can be blank
    memberId: "", //can be blank
    publisher: "", //can be blank
    entityContentSearch: get(SEARCH_PARAMS.ENTITY_CONTENT_SEARCH) || "",
    entityDetailsSearch: get(SEARCH_PARAMS.ENTITY_DETAILS_SEARCH) || "",
    page: +get(SEARCH_PARAMS.CURRENT_PAGE) || 1,
    size: +get(SEARCH_PARAMS.PAGE_SIZE) || 10,
    publisherFilter:
      selectedFilterBy?.split(":")?.[0] ||
      get(SEARCH_PARAMS.FILTER_BY)?.split(":")?.[0] ||
      "ALL",
    filterByMemberId:
      selectedFilterBy?.split(":")?.[1] ||
      get(SEARCH_PARAMS.FILTER_BY)?.split(":")?.[1] ||
      null,
    clickedValue: "",
  });

  const axiosService = new AxiosService();

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    if (tab === tabList[0]) {
      // setQueryData((prev) => ({
      //   ...prev,
      //   memberId: "", //
      //   filter: "",
      //   sortKey: "title",
      // }));
      setSelectedPublisher("workCount");
    }
  };

  const handlePublisherSort = (order, field) => {
    setQueryData((prev) => ({
      ...prev,
      sortKey: field,
      sortOrder: order,
    }));
  };

  const handleGoBack = () => {
    setShowActiveTab(true);
    setQueryData((prev) => ({
      ...prev,
      publisherFilter: selectedFilterBy?.split(":")?.[0],
      // publisherFilter: "ALL",
      sortKey: "workCount",
      memberId: "",
      agencyId: "",
      clickedFunder: "",
    }));
    setActiveTab(tabList[1]);
  };

  const handleRowClick = (rowData, field) => {
    setShowActiveTab(false);
    setActiveTab(tabList[0]);
    setSelectedPublisher(field);
    setQueryData((prev) => ({
      ...prev,
      memberId: rowData.memberId || rowData.agencyId || "",
      agencyId: rowData.agencyId,
      publisherFilter: "CHORUS_MEMBER",
      publisher: rowData.publisher || rowData.funder || "",
      filter: field || "",
      sortKey: "title",
      clickedFunder: rowData.shortName,
    }));
  };

  const handleSearch = (searchText) => {
    // setQueryData((prev) => ({
    //   ...prev,
    //   entityContentSearch: searchText,
    //   page: 1,
    // }));
  };

  const handleOnChange = (searchText) => {
    setQueryData((prev) => ({
      ...prev,
      entityContentSearch: searchText,
      page: 1,
    }));
  };

  const handleDetailsSearchChange = (searchText) => {
    setQueryData((prev) => ({
      ...prev,
      entityDetailsSearch: searchText,
      page: 1,
    }));
  };

  // useEffect(() => {
  //   if (!selectedPublisher) {
  //     setSelectedPublisher("workCount");
  //   }
  // }, []);


  useEffect(() => {
    setMultiple({
      [SEARCH_PARAMS.TAB]: activeTab,
      [SEARCH_PARAMS.PAGE_SIZE]: queryData.size,
      [SEARCH_PARAMS.SORT_KEY]: queryData.sortKey,
      [SEARCH_PARAMS.SORT_ORDER]: queryData.sortOrder,
      [SEARCH_PARAMS.CURRENT_PAGE]: queryData.page,
      [SEARCH_PARAMS.ENTITY_CONTENT_SEARCH]: queryData.entityContentSearch,
      [SEARCH_PARAMS.ENTITY_DETAILS_SEARCH]: queryData.entityDetailsSearch,
      [SEARCH_PARAMS.ACTIVE_METRICS_CARD]: selectedPublisher,
      [SEARCH_PARAMS.FILTER_BY]:
        selectedFilterBy || get(SEARCH_PARAMS.FILTER_BY),
      [SEARCH_PARAMS.FILTER_BY_NAME] : ["All funders", "All publishers"].includes(selectedFilterByLabel) ? undefined : selectedFilterByLabel?.trim() || get(SEARCH_PARAMS.FILTER_BY_NAME)
    });
  }, [queryData, activeTab, selectedPublisher, selectedFilterByLabel]);

  useEffect(() => {
    if (selectedFilterBy) {
      setQueryData((prev) => ({
        ...prev,
        publisherFilter: selectedFilterBy.split(":")?.[0],
        filterByMemberId: selectedFilterBy.split(":")?.[1] || null,
      }));
    }
  }, [selectedFilterBy]);

  useEffect(() => {
    if (activeTab === tabList[1]) {
      setQueryData((prev) => ({
        ...prev,
        page: 1,
        sortKey: "workCount",
        entityDetailsSearch: "",
        // queryData.sortKey === "title" ? "workCount" : queryData.sortKey,
      }));
    }
    if (activeTab === tabList[0]) {
      setQueryData((prev) => ({
        ...prev,
        page: 1,
        sortKey: "title", //"title",
      }));
    }
  }, [activeTab]);

  useEffect(() => {
    if (publisherCount?.[selectedPublisher] >= 0) {
      setQueryData((prev) => ({
        ...prev,
        filter: selectedPublisher,
        page: 1,
        clickedValue: publisherCount?.[selectedPublisher] || 0,
      }));
    }
  }, [selectedPublisher, publisherCount]);

  useEffect(() => {
    // if (activeTab !== "Publisher Content") return;
    if (queryData) {
      setLoading(true);
      switch (entityName) {
        case KEY_NAME.FUNDER:
          if (activeTab === tabList[1]) {
            axiosService
              .getPublisherReport(queryData, shortName)
              .then((response) => {
                setPublisherReportData(response.data);
              })
              .catch((error) => {
                console.error("Publisher Report Error:", error);
              })
              .finally(() => {
                setLoading(false); // STOP LOADER
              });
          } else if (
            activeTab === tabList[0] &&
            queryData.clickedValue !== "" &&
            queryData.clickedValue >= 0
          ) {
            axiosService
              .getPublicationDetails(queryData, shortName)
              .then((response) => {
                setPublicationDetailsData(response.data);
              })
              .catch((error) => {
                console.error("Publisher Report Error:", error);
              })
              .finally(() => {
                setLoading(false); // STOP LOADER
              });
          }

          break;
        case KEY_NAME.PUBLISHER:
          if (activeTab === tabList[1]) {
            axiosService
              .getFundersReport(queryData, shortName)
              .then((response) => {
                setPublisherReportData(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setLoading(false);
              });
          } else if (
            activeTab === tabList[0] &&
            queryData.clickedValue !== "" &&
            queryData.clickedValue >= 0
          ) {
            axiosService
              .getFunderDetails(queryData, shortName)
              .then((response) => {
                setPublicationDetailsData(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setLoading(false);
              });
          }
          break;
        case KEY_NAME.INSTITUTION:
          if (activeTab === tabList[1]) {
            axiosService
              .getFundersReport(queryData, shortName)
              .then((response) => {
                setPublisherReportData(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setLoading(false);
              });
          } else if (
            activeTab === tabList[0] &&
            queryData.clickedValue !== "" &&
            queryData.clickedValue >= 0
          ) {
            axiosService
              .getFunderDetails(queryData, shortName)
              .then((response) => {
                setPublicationDetailsData(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setLoading(false);
              });
          }
          break;

        default:
          break;
      }
    }
  }, [queryData, entityName]);

  useEffect(() => {
    // if (activeTab !== "Publisher Content") return;
    const isChorus = queryData.publisherFilter === "CHORUS_MEMBER";

    const hasMember = queryData.filterByMemberId || queryData.memberId;

    if (isChorus && !hasMember) return;

    if (shortName && queryData.publisherFilter) {
      setMetricsLoading(true);
      switch (entityName) {
        case KEY_NAME.FUNDER:
          if (activeTab === tabList[0]) {
            axiosService
              .getPublisherCount(queryData, shortName)
              .then((response) => {
                setPublisherCount(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setMetricsLoading(false);
              });
          }

          break;
        case KEY_NAME.PUBLISHER:
          if (activeTab === tabList[0]) {
            axiosService
              .getFunderCount(queryData, shortName)
              .then((response) => {
                setPublisherCount(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setMetricsLoading(false);
              });
          }
          break;
        case KEY_NAME.INSTITUTION:
          if (activeTab === tabList[0]) {
            axiosService
              .getFunderCount(queryData, shortName)
              .then((response) => {
                setPublisherCount(response.data);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setMetricsLoading(false);
              });
          }
          break;

        default:
          break;
      }
    }
  }, [
    queryData.memberId,
    queryData.filterByMemberId,
    queryData.publisherFilter,
    shortName,
    entityName,
    activeTab,
  ]);

  const renderTabContent = () => {
    switch (activeTab) {
      case tabList[1]:
        return (
          <div className="publisher-content-wrapper">
            {/* {loading && <Loader overlay size="md" />} */}

            <PublisherContent
              tableData={publisherReportData || []}
              totalRecords={publisherReportData?.total || 0}
              queryData={queryData}
              setQueryData={setQueryData}
              handleSort={handlePublisherSort}
              disabled={loading}
              handleRowClick={handleRowClick}
              loading={loading}
              onSearch={handleSearch}
              onChange={handleOnChange}
            />
          </div>
        );
      case tabList[0]:
        return (
          <PublicationDetails
            tableData={publicationDetailsData || []}
            setTableData={setPublicationDetailsData}
            totalRecords={publicationDetailsData?.total || 0}
            publisherCount={publisherCount}
            selectedPublisher={selectedPublisher}
            setSelectedPublisher={setSelectedPublisher}
            queryData={queryData}
            setQueryData={setQueryData}
            handleSort={handlePublisherSort}
            onRowClick={handleRowClick}
            // disabled={loading}
            metricsLoading={metricsLoading}
            loading={loading}
            onSearch={handleSearch}
            onChange={handleDetailsSearchChange}
          />
        );

      default:
        return null;
    }
  };
  return (
    <div className="publication-analytics">
      <HeaderNavigate
        // label={`Funder Dashboard / ${get(SEARCH_PARAMS.ENTITY_NAME)}`}
        showFilter={true}
      />

      <div className="bg-light text-start py-4 px-3 mb-4">
        <EntityHeader
          metaInfo={metaInfo}
          dashboardType={entityName}
          title={get(SEARCH_PARAMS.ENTITY_NAME)}
        />

        {showActiveTab && <FilterBy />}
      </div>

      <div className="dataset-analytics-container mb-3">
        {metaInfo && showActiveTab && (
          <div className="container px-0">
            <div className="row">
              <div className="col-12 col-sm-10">
                <MetricsCard
                  title="Last Updated"
                  value={formattedDate || metaInfo?.lastUpdateDate || "N/A"}
                  change=""
                  changeLabel=""
                  isDate={true}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {!showActiveTab && (
        <div className="d-flex flex-column justify-content-center align-items-start text-start">
          <span role="button" className=" mb-1" onClick={handleGoBack}>
            <FontAwesomeIcon icon={faAngleLeft} />
            <span> Go Back</span>
          </span>
          <span className="ps-1 fs-4 mb-1">{queryData.publisher}</span>
        </div>
      )}
      {/* Tabs */}
      {showActiveTab && (
        <div className="tab-container">
          <Tabs
            tabs={
              tabList
              // entityName === "funder"
              //   ? ["Publisher Content", "Publication Details"]
              //   : ["Funder Content", "Funder Details"]
            }
            active={activeTab}
            onChange={(tab) => {
              handleTabChange(tab);
            }}
          />
        </div>
      )}
      <div className="tab-content">{renderTabContent()}</div>
      {/* <div className="my-5 mx-auto me-3">
   <ImageContainer />
 </div> */}
    </div>
  );
};

export default PublicationData;
